module.exports = __webpack_public_path__ + "img/plan01_text02.c28b3440.png";